const S3_VIRTUAL_HOST_MARK = '.s3.amazonaws.com/';
const MAX_CACHED_FILES = 50;

const filesByLink = new Map<string, File>();

export const rememberUploadedFile = (link: unknown, file: File): void => {
  if (typeof link !== 'string' || !link.includes(S3_VIRTUAL_HOST_MARK)) return;

  filesByLink.set(link, file);

  while (filesByLink.size > MAX_CACHED_FILES) {
    const oldest = filesByLink.keys().next();
    if (oldest.done) return;
    filesByLink.delete(oldest.value);
  }
};

export const getUploadedFile = (link: string): File | undefined => filesByLink.get(link);
